export default "__VITE_ASSET__UYDHSMj2__"